export default "__VITE_ASSET__CCAec1Jj__"